export const EMAILJS_CONFIG = {
    SERVICE_ID: "service_rbe0ezu",
    TEMPLATE_ID: "template_csfkiyp",
    PUBLIC_KEY: "2zdqmx-25RugfO-Bi"
}